// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".session-bg {\n  background-color: white;\n  height: 100vh;\n  align-items: center;\n  place-content: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n}\n.signup4-header img {\n  width: 200px;\n}\n.signup4-container img {\n  max-height: 300px;\n  max-width: 100%;\n}\n@media only screen and (min-width: 1024px) {\n.signup4-container {\n    max-width: 800px;\n}\n}", ""]);
// Exports
module.exports = exports;
